/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, memo, useRef } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Button, Image } from "react-bootstrap";
import { Select } from "antd";
import "./report.css";
import axiosInstance from "../../axios/axios";
import Loader from "../popups/Loading";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";
import {
  Table,
  TableHeadCell,
  TableBody,
  TableBodyCell,
  TableHead,
} from "../setting/PatientPortalSettings/StyledComponents";
import { Tablerow } from "../patient/StyledComponent";
import { globalColor, globalFont } from "../utils/RepeatFunctions/Schedule";
import CustomSuffixIcon from "../popups/CustomSuffixIcon";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { CSVLink } from "react-csv";
import { parsePhoneForDisplay } from "../patient/ParsePhoneForDisplay";
import { AiOutlineSearch } from "react-icons/ai";
import { AutoComplete } from "antd";
const AgingTable = () => {
  //------------------------------------------ State and Variables Start ------------------------------------------------------- //
  const csvLinkRef = useRef(null);
  const dateFormat = localStorage.getItem("dateFormat");

  const [agingdata, setagingdata] = useState([]);
  const [mainrows, setmainrows] = useState([]);
  const [filtervar, setfiltervar] = useState([]);
  const [spinner, setspinner] = useState(true);
  const [showLoading, setShowLoading] = useState("reportDivblock");
  const [load_flag, setload_flag] = useState(0);
  const [office, setoffice] = useState("");
  const [getdata, setgetdata] = useState("patient");
  const [providerdata, setproviderdata] = useState(false);
  const [facilityFilter, setFacilityFilter] = useState([]);
  const currency = useSelector((state) => state.Report.Currency);

  const [csvData, setcsvData] = useState([]);
  const [frExpDt, setFrExpDt] = useState(
    moment().add(-7, "days").format("YYYY-MM-DD"),
  );
  const [toExpDt, setToExpDt] = useState(moment().format("YYYY-MM-DD"));

  const offset = 0;
  const limit = 40;

  let storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  let user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  let authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  let main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  let owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  let group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");
  let endpoint = `/vozo/getAgeingReportPatientId`;
  const { Option } = Select;

  //------------------------------------------ State and Variables End -------------------------------------------------------- //

  // ----------------------------------------- Functions Start ---------------------------------------------------------------- //
  const handleExportClick = (event) => {
    event.preventDefault();

    csvLinkRef.current.link.click();
  };

  const cptfilter = () => {
    setspinner(true);
    setagingdata([]);

    if (getdata === "patient") {
      setproviderdata(false);
      endpoint = `/vozo/getAgeingReportPatientId?providerId=${user_ID}&office=${office}&limit=${limit}&offset=${offset}`;
    } else if (getdata === "provider") {
      setproviderdata(true);
      endpoint = `/vozo/getAgeingReportForProvider?provider_id=${user_ID}&office=${office}&limit=${limit}&offset=${offset}`;
    } else if (getdata === "payer") {
      setproviderdata(false);
      endpoint = `/vozo/getAgeingReportForPayer?limit=${limit}&offset=${offset}&office=${office}`;
    } else {
      setspinner(false); // ✅ Stop spinner if there's an invalid selection
      return;
    }
    firstloadTenPokemon();
  };

  const firstloadTenPokemon = async () => {
    setspinner(true);
    try {
      const separator = endpoint.includes("?") ? "&" : "?";
      const response = await axiosInstance.get(
        `${endpoint}${separator}providerId=${user_ID}&authorized=${authorized}&main_pro=${main_pro}&owner_id=${owner_id}&userID=${user_ID}&pat_share=${storedNames.pat_share}`,
      );
      const DecodeVal = Decrypt_Value(response.data, "vozo");

      if (
        Array.isArray(DecodeVal) &&
        DecodeVal.length > 0 &&
        DecodeVal.some((item) => item.length !== 0)
      ) {
        setmainrows(DecodeVal); // Store all data in mainrows
        setagingdata(DecodeVal.slice(0, 15)); // Show first 15 items
        setcsvData(DecodeVal);
        setShowLoading(
          DecodeVal.length > 15 ? "reportDivblock" : "reportDivnone",
        );
      } else {
        setagingdata([]);
        setmainrows([]);
        setShowLoading("reportDivnone"); // Ensure button is hidden when there's no data
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setagingdata([]);
      setmainrows([]);
      setcsvData([]);
    }
    setspinner(false);
  };

  const loadTenPokemon = () => {
    const currentLength = agingdata.length;
    const remainingItems = mainrows.slice(currentLength, currentLength + 15);

    // Load from local cache
    if (remainingItems.length > 0) {
      setagingdata((prev) => [...prev, ...remainingItems]);
      setShowLoading(
        mainrows.length > agingdata.length + 15
          ? "reportDivblock"
          : "reportDivnone",
      );
      return;
    }

    // Fetch from server when local cache exhausted
    if (load_flag === 0) {
      setload_flag(1);
      setShowLoading("reportDivblock");

      const article = {
        cptcode: filtervar.cptcode,
        cpttype: filtervar.cpttype,
        fromdate: filtervar.fromdate,
        todate: filtervar.todate,
        limit: 40,
        offset: mainrows.length, // Use mainrows length as offset
        authorized: authorized,
        main_pro: main_pro,
        owner_id: owner_id,
        userID: user_ID,
        pat_share: storedNames.pat_share,
        office: office,
        getdata: getdata,
      };

      axiosInstance
        .put("/vozo/daysheetcharges", Encrypt_Value(article, "vozo"))
        .then((response) => {
          const newData = Decrypt_Value(response.data, "vozo");
          if (newData?.length) {
            const updatedMain = [...mainrows, ...newData];
            setmainrows(updatedMain);
            setagingdata(updatedMain.slice(0, currentLength + 15));
            setShowLoading(
              newData.length >= 40 ? "reportDivblock" : "reportDivnone",
            );
          }
          setload_flag(0);
        })
        .catch((error) => {
          console.error("Error loading more:", error);
          setload_flag(0);
        })
        .finally(() => {
          setspinner(false);
        });
    }
  };

  const fetchFacilities = async () => {
    let Data_frsh_doc =
      "authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&group_id=" +
      group_id;
    let Data_enc_doc = Encrypt_Value(Data_frsh_doc, "vozo");
    await axiosInstance
      .get("/vozonew/facility?search=" + Data_enc_doc)
      .then((response) => {
        let decryptval = Decrypt_Value(response.data, "vozo");
        setFacilityFilter(decryptval);
      })
      .catch((err) => console.error(err));
  };

  // ----------------------------------------- Functions End ------------------------------------------------------------------ //

  // ----------------------------------------- UseEffect Start --------------------------------------------------------------- //

  useEffect(() => {
    fetchFacilities();
    setmainrows([]);
    setagingdata([]);
    firstloadTenPokemon();
    setTimeout(() => setspinner(false), 3000);
  }, []);

  useEffect(() => {
    if (agingdata.length === mainrows.length) {
      setShowLoading("reportDivnone");
    }
  }, [agingdata]);

  // ----------------------------------------- UseEffect End ---------------------------------------------------------------- //

  return (
    <div>
      {spinner ? (
        <Loader />
      ) : (
        <>
          <div className="tab_aging_main">
            <div className="tab_title_name">Aging Report</div>
          </div>
          <div className="bg-back_report backgr-chng for-aging-top">
            <div>
              <div className="d-flex ">
                <div className="tele-select-btn m-l-25">
                  <Select
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Facility"
                    className="w-210 t-a-l antd-dd-tele_repo ant-sel-hei34 "
                    suffixIcon={<CustomSuffixIcon />}
                    onChange={(e, data) => setoffice(data.value)}
                    value={office ? office : undefined}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.title ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {facilityFilter && facilityFilter.length > 0 ? (
                      facilityFilter.map((item) => (
                        <Option key={item.id} value={item.id} title={item.name}>
                          {item.name}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>No facilities available</Option>
                    )}
                  </Select>
                </div>
                <div className="aging-search"> Search by</div>
                <div className="tele-select-btn">
                  <Select
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    // placeholder="Facility"
                    className="w-210 t-a-l antd-dd-tele_repo ant-sel-hei34 "
                    suffixIcon={<CustomSuffixIcon />}
                    onChange={(e, data) => {
                      setgetdata(data.value);
                    }}
                    value={getdata ? getdata : undefined}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.title ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    <Option key={1} value="patient">
                      Patient
                    </Option>
                    <Option key={2} value="payer">
                      Payer
                    </Option>
                    <Option key={3} value="provider">
                      Provider
                    </Option>
                  </Select>
                </div>
                <Button
                  variant="primary"
                  onClick={cptfilter}
                  className="m-l-16 create-appt edit-note input-size btn-fnt-wgt button_Click_event_alt"
                  id="rpt_proc-btn_upt"
                >
                  Update
                </Button>
                <div style={{ position: "absolute", right: "32px" }}>
                  <CSVLink
                    ref={csvLinkRef}
                    data={csvData}
                    filename={"aging_report"}
                    // headers={headers}
                  >
                    <Button
                      disabled={csvData.length === 0}
                      variant="success"
                      className="reportExpBtn"
                      // onClick={handleExportClick}
                    >
                      Export File to csv
                    </Button>
                  </CSVLink>
                </div>
              </div>
            </div>
          </div>
          <>
            <div className="table-boder-pad_down2">
              <div className=" table-for-template1">
                <Table minWidth="650px">
                  <TableHead
                    className="Tab_content_Table_Header appt-head"
                    display="table-header-group"
                    height="40px"
                  >
                    <Tablerow
                      className="schedule-head-row tr-no aging-head-row"
                      fontWeight="400"
                      color={globalColor}
                    >
                      <TableHeadCell width={providerdata ? "17%" : "20%"}>
                        <div>Responsible party</div>
                      </TableHeadCell>
                      <TableHeadCell
                        align="left"
                        width={providerdata ? "10%" : "14%"}
                      >
                        0-30 days
                      </TableHeadCell>
                      <TableHeadCell
                        align="left"
                        width={providerdata ? "10%" : "14%"}
                      >
                        31-60 days
                      </TableHeadCell>
                      <TableHeadCell
                        align="left"
                        width={providerdata ? "10%" : "14%"}
                      >
                        61-90 days
                      </TableHeadCell>
                      <TableHeadCell
                        align="left"
                        width={providerdata ? "10%" : "14%"}
                      >
                        91-120 days
                      </TableHeadCell>
                      <TableHeadCell
                        align="left"
                        width={providerdata ? "13%" : "14%"}
                      >
                        Above 120 days
                      </TableHeadCell>
                      {providerdata ? (
                        <>
                          <TableHeadCell align="left" width="10%">
                            Patient
                          </TableHeadCell>
                          <TableHeadCell align="left" width="10%">
                            Insurance
                          </TableHeadCell>
                        </>
                      ) : (
                        ""
                      )}
                      <TableHeadCell
                        align="left"
                        paddingRight="16px"
                        width={providerdata ? "10%" : "14%"}
                      >
                        Total
                      </TableHeadCell>
                    </Tablerow>
                  </TableHead>
                  {agingdata.length > 0 ? (
                    <>
                      <TableBody
                        display="table-row-group"
                        className="Boreder_none"
                      >
                        {agingdata.map((row, ind) => (
                          <Tablerow
                            className="table-data-row schedule-body-row"
                            color="#636d73"
                            lineHeight="20.01px"
                            fontFamily={globalFont}
                            borderBottom="1px solid #cbd5e0"
                            padding="6px 0px 6px 18px"
                            height="40px"
                          >
                            <TableBodyCell
                              className="name-overflow-table-cell"
                              scope="row"
                              title={row?.responsible_party}
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip>{row?.responsible_party}</Tooltip>
                                }
                              >
                                <span>{row?.responsible_party}</span>
                              </OverlayTrigger>
                            </TableBodyCell>

                            {[
                              "balance_0_30_days",
                              "balance_31_60_days",
                              "balance_61_90_days",
                              "balance_91_120_days",
                              "balance_above_120_days",
                            ].map((field, index) => {
                              const value = parseFloat(row[field] || 0).toFixed(
                                2,
                              ); // ✅ Ensure valid number
                              const truncatedValue =
                                value.length > 8
                                  ? `${value.slice(0, 8)}...`
                                  : value; // ✅ Truncate if too long

                              return (
                                <TableBodyCell
                                  key={index}
                                  align="left"
                                  width={providerdata ? "10%" : "14%"}
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-${index}`}>
                                        {value}
                                      </Tooltip>
                                    }
                                  >
                                    <span
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "inline-block",
                                        maxWidth: "80px",
                                      }}
                                    >
                                      {currency} {truncatedValue}
                                    </span>
                                  </OverlayTrigger>
                                </TableBodyCell>
                              );
                            })}

                            {providerdata && (
                              <>
                                <TableBodyCell align="left" width="10%">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>{`${currency} ${parseFloat(
                                        row.patient_balance || 0,
                                      ).toFixed(2)}`}</Tooltip>
                                    }
                                  >
                                    <span
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "inline-block",
                                        maxWidth: "80px",
                                      }}
                                    >
                                      {(() => {
                                        const patientBalanceDue = parseFloat(
                                          row.patient_balance || 0,
                                        ).toFixed(2);
                                        return patientBalanceDue.length > 8
                                          ? `${patientBalanceDue.slice(
                                              0,
                                              8,
                                            )}...`
                                          : `${currency} ${patientBalanceDue}`;
                                      })()}
                                    </span>
                                  </OverlayTrigger>
                                </TableBodyCell>

                                <TableBodyCell align="left" width="10%">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>{`${currency} ${parseFloat(
                                        row.insurance_balance || 0,
                                      ).toFixed(2)}`}</Tooltip>
                                    }
                                  >
                                    <span
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "inline-block",
                                        maxWidth: "80px",
                                      }}
                                    >
                                      {(() => {
                                        const insuranceBalanceDue = parseFloat(
                                          row.insurance_balance || 0,
                                        ).toFixed(2);
                                        return insuranceBalanceDue.length > 8
                                          ? `${insuranceBalanceDue.slice(
                                              0,
                                              8,
                                            )}...`
                                          : `${currency} ${insuranceBalanceDue}`;
                                      })()}
                                    </span>
                                  </OverlayTrigger>
                                </TableBodyCell>
                              </>
                            )}

                            <TableBodyCell
                              align="left"
                              paddingRight="16px"
                              width={providerdata ? "10%" : "14%"}
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip>
                                    {parseFloat(
                                      row.total_balance_due || 0,
                                    ).toFixed(2)}
                                  </Tooltip>
                                }
                              >
                                <span
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "inline-block",
                                    maxWidth: "80px",
                                  }}
                                >
                                  {(() => {
                                    const totalAmount = parseFloat(
                                      row.total_balance_due || 0,
                                    ).toFixed(2); // ✅ Ensure valid number
                                    return totalAmount.length > 8
                                      ? `${currency} ${totalAmount.slice(
                                          0,
                                          8,
                                        )}...`
                                      : `${currency} ${totalAmount}`;
                                  })()}
                                </span>
                              </OverlayTrigger>
                            </TableBodyCell>
                          </Tablerow>
                        ))}
                      </TableBody>
                    </>
                  ) : (
                    <>
                      <TableBody>
                        <Tablerow className="bot_border">
                          <TableBodyCell
                            className="CreditRowAlign"
                            colSpan={providerdata ? 9 : 7}
                          >
                            <div className="img_top">
                              <Image
                                height="133px"
                                width="133px"
                                src={Emp_data_pic}
                              ></Image>
                            </div>
                          </TableBodyCell>
                        </Tablerow>
                      </TableBody>
                    </>
                  )}
                </Table>
              </div>
            </div>
          </>
          {agingdata.length !== 0 && (
            <div
              className={
                "loading-more-pro-proc recharts-legend-wrapper " + showLoading
              }
            >
              <Button
                id="load-data"
                variant="primary"
                className={
                  "loading-more-div recharts-legend-wrapper " + showLoading
                }
                onClick={loadTenPokemon}
              >
                Load more...
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default memo(AgingTable);
